<button style="height: 30px;" mat-flat-button color="primary" [matMenuTriggerFor]="menu">
  {{isCurrentUserFollowing() ? 'Following':'Followers'}} <mat-icon>{{isCurrentUserFollowing() ? 'verified':'person_add_alt_1'}}</mat-icon>
</button>

<mat-menu #menu="matMenu">
  <button mat-menu-item *ngFor="let follower of currentLead?.lead_subscriptions" class="custom-menu-item">
    {{follower.user.name}} {{follower.user.lastName}}
    <mat-icon class="icon-delete"  (click)="$event.stopPropagation(); removeUser(follower)">delete_outline</mat-icon>
    <mat-icon class="icon-person">person</mat-icon>

  </button>
  <hr/>
  <!-- Conditionally render buttons based on whether the current user is following -->
  <button *ngIf="!isCurrentUserFollowing()" (click)="$event.stopPropagation();followCurrentUser()" mat-menu-item class="custom-menu-item">
    Start subscription <mat-icon>notifications_on</mat-icon>
  </button>
  <button *ngIf="isCurrentUserFollowing()" (click)="$event.stopPropagation();unfollowCurrentUser()" mat-menu-item class="custom-menu-item">
    Stop subscription <mat-icon>notifications_off</mat-icon>
  </button>

  <!-- Always show the "Add follower" button -->
  <button mat-menu-item class="custom-menu-item" *ngIf="isCurrentUserOwnerOrSecondaryOwner()" (click)="addFollowers()">
    Add follower <mat-icon>person_add</mat-icon>
  </button>
</mat-menu>